import type {AxiosRequestConfig} from 'axios';

export class GetTokensBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners/',
    params: {},
  };

  params(params: object) {
    this.tokensRequest.params = params;
    return this;
  }

  id(id: number) {
    this.tokensRequest.url = `/partners/${id}/tokens`;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}

export class GetTokenBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners/',
    params: {},
  };

  params(params: object) {
    this.tokensRequest.params = params;
    return this;
  }

  id(id: number) {
    this.tokensRequest.url = `/partners/${id}/token`;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}

export class RevokeTokenBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partners/',
    params: {},
  };

  params(params: object) {
    this.tokensRequest.params = params;
    return this;
  }

  id(id: number) {
    this.tokensRequest.url = `/partners/${id}/token/revoke`;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}

export class RenewTokenBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partners/',
    params: {},
  };

  data(params: object) {
    this.tokensRequest.data = params;
    return this;
  }

  id(id: number) {
    this.tokensRequest.url = `/partners/${id}/token/renew`;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}

export class RegisterShopUrlBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/tps-management/third-party-partner',
    data: {},
  };

  data(data: object) {
    this.tokensRequest.data = data;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}

export class GetShopInfoBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/tps-management/third-party-partner',
    params: {},
  };

  build() {
    return this.tokensRequest;
  }
}

export class InitializeBasalamOAuthBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/tps-management/basalam/oauth/initialize',
    params: {},
  };

  build() {
    return this.tokensRequest;
  }
}

export class RegisterBasalamTokenBuilder {
  private readonly tokensRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/tps-management/basalam/token',
    data: {},
    params: {}
  };

  params(params: object) {
    this.tokensRequest.params = params;
    return this;
  }

  build() {
    return this.tokensRequest;
  }
}